<app-attendee-card
  [toptitle]="sportName"
  [title]="activity.name"
  [subtitle]="formattedAddress"
  [imageSrc]="picture"
  [showImageOverlay]="showFullActivityOverlay"
  [organizationName]="organizationName"
>
  <app-badge
    top-right-content
    #topRightContent
    class="absolute top-2 right-2"
    [variant]="badgeVariant.YELLOW"
  >
    {{
      this.activity?.startingPrice?.amount
        | displayPrice
          : this.activity?.startingPrice?.currency
          : this.activity?.highestPrice?.amount
    }}
  </app-badge>

  <app-badge
    *ngIf="isBg && this.activity?.startingPrice?.amount !== 0"
    top-right-content
    #topRightContent
    class="absolute top-6 right-2"
    [variant]="badgeVariant.YELLOW"
  >
    {{
      activity.startingPrice?.amount
        | priceConversion
        | displayPrice: '€' : (activity.highestPrice?.amount | priceConversion)
    }}
  </app-badge>

  <ng-container
    image-overlay-content
    #imageOverlayContent
    *ngIf="showFullActivityOverlay"
  >
    <p
      class="inline-block mt-4 border-b-4 border-grey-light-1 text-grey-light-1 text-3xl font-condensed italic font-bold transform skew-x-decathlon"
    >
      {{ 'attendee.activity_detail.picture.full_activity' | translate }}
    </p>
  </ng-container>

  <div class="flex flex-wrap">
    <ng-container *appIsEnabled="toggleNameEnum.ActivityCardTimeslots">
      <app-badge
        *ngIf="formattedDate"
        class="mt-2 mr-2"
        [variant]="informationBadgeVariant"
      >
        {{ formattedDate }}
      </app-badge>
    </ng-container>

    <app-badge
      class="mt-2 mr-2"
      [variant]="informationBadgeVariant"
      *ngIf="ISODuration"
    >
      <time class="whitespace-nowrap" [attr.datetime]="ISODuration">
        {{ duration }}
      </time>
    </app-badge>

    <app-badge class="mt-2 mr-2" [variant]="informationBadgeVariant">
      {{ activity.typicalAgeRange | displayAgeRange }}
    </app-badge>
  </div>
  <ng-container *appIsEnabled="toggleNameEnum.ActivityCardRating">
    <div
      appObserveElement
      #intersection="intersection"
      (isIntersecting)="isIntersecting($event)"
      class="h-4"
    >
      <app-vtmn-rating
        *ngIf="reviewsStats?.count > 0"
        class="mt-2"
        [compact]="true"
        [showValue]="true"
        [value]="reviewsStats?.averageRating"
        [comments]="
          'activity.reviews.count-reviews'
            | translate: { reviewQuantity: reviewsStats?.count?.toString() }
        "
        [size]="ratingSizeEnum.SMALL"
        [emphasis]="true"
      ></app-vtmn-rating>
    </div>
  </ng-container>
</app-attendee-card>
